import React, { useEffect, useState } from "react";

function Tvseries() {
  const [tvseriesData, tvSeriesData] = useState([]);
  const [type, setType] = useState("/tv/popular");
  const api_key = "1c349502ffa6fe67721a2ea4260bed9f";
  const api_url = "https://api.themoviedb.org/3/";

  const getResponseData = async () => {
    const data = await fetch(
      `${api_url}/${type}?api_key=${api_key}&language=en-US&page=1`
    );
    const response = await data.json();
    console.log("res", response.results);
    tvSeriesData(response.results);
  };
  useEffect(() => {
    getResponseData();
  }, [type]);
  return (
    <>
      <section className="tv-series">
        <div className="container">
          <p className="section-subtitle">Best TV Series</p>

          <h2 className="h2 section-title">Tv shows</h2>
          <ul className="filter-list">
            <li>
              <button
                onClick={() => setType("/tv/top_rated")}
                className="filter-btn"
              >
                Top rated
              </button>
            </li>

            <li>
              <button
                onClick={() => setType("/tv/popular")}
                className="filter-btn"
              >
                Popular Tv Shows
              </button>
            </li>
          </ul>

          <ul className="movies-list">
            {tvseriesData.map((item) => (
              <li>
                <div className="movie-card">
                  <a href="./movie-details.html">
                    <figure className="card-banner">
                      <img
                        src={`https://image.tmdb.org/t/p/w500/${item.poster_path}`}
                        alt=""
                      />
                    </figure>
                  </a>

                  <div className="title-wrapper">
                    <a href="./movie-details.html">
                      <h3 className="card-title">{item.name}</h3>
                    </a>

                    <time datetime="2022">{item.first_air_date}</time>
                  </div>

                  <div className="card-meta">
                    <div className="badge badge-outline">
                      {item.original_language}
                    </div>

                    {/* <div className="duration">
                      <ion-icon name="time-outline"></ion-icon>

                      <time datetime="PT47M">{item.time}</time>
                    </div> */}

                    <div className="rating">
                      <ion-icon name="star"></ion-icon>

                      <data>{item.vote_average}</data>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </>
  );
}

export default Tvseries;
